(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-section-1"] && !Shopify.designMode) return;
  try {
    
// Javascript
  
// end of Javascript  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new_page"] && !Shopify.designMode) return;
  try {
    
// Javascript

// end of Javascript

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tensile-chart"] && !Shopify.designMode) return;
  try {
    
$('.tab-menu li a').on('click', function(){

    var target = $(this).attr('data-rel');

    $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
});

//const ctx = document.getElementById('myChart');

//   new Chart(ctx, {
//     type: 'line',
//     data: {
//       labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
//       datasets: [{
//         label: '# of Votes',
//         data: [0,10,20,30,38,40,38,45,50,50,45,39,34,29],
//         borderWidth: 3,
//         borderColor: '#EC0000', 
//         fill: true,
//         backgroundColor: '#ff000036',
//         lineTension: 0.5,
//       },
//       {
//         label: '# of ALTERNATIVES',
//         data: [0,7,17,27,35,37,35,42,47,47,42,36,31,26],
//         borderWidth: 3,
//         borderColor: '#8630FF', 
//         fill: true,
//         backgroundColor: '#d898d699',
//         lineTension: 0.5,
//       }]
//     },
//     options: {
//     //   scales: {
//     //     y: {
//     //       beginAtZero: true
//     //     }
//     //   }
//     }
// });

// const ctx2 = document.getElementById('myChart2');

//   new Chart(ctx2, {
//     type: 'line',
//     data: {
//       labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
//       datasets: [{
//         label: '# of Votes',
//         data: [0,10,20,30,38,40,38,45,50,50,45,39,34,29],
//         borderWidth: 3,
//         borderColor: '#EC0000', 
//         fill: true,
//         backgroundColor: '#ff000036',
//         lineTension: 0.5,
//       },
//       {
//         label: '# of ALTERNATIVES',
//         data: [0,7,17,27,35,37,35,42,47,47,42,36,31,26],
//         borderWidth: 3,
//         borderColor: '#8630FF', 
//         fill: true,
//         backgroundColor: '#d898d699',
//         lineTension: 0.5,
//       }]
//     },
//     options: {
//     //   scales: {
//     //     y: {
//     //       beginAtZero: true
//     //     }
//     //   }
//     }
// });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-form"] && !Shopify.designMode) return;
  try {
    
$('.tab-menu li a').on('click', function(){

    var target = $(this).attr('data-rel');

    $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xotic-engine-explorer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('xotic-engine-explorer')) return;
  let libraries, libraryAttempt = 0;
  function getLibraries() {
    if (!libraries) libraries = (async () => {
      const attempt = libraryAttempt++;
      const base = 'https://esm.sh/three@0.170.0/es2022/';
      const coreUrl = base + 'three.mjs' + (attempt ? '?xee_retry=' + attempt : '');
      const fetchModule = async name => {
        const response = await fetch(base + 'examples/jsm/' + name + '.mjs');
        if (!response.ok) throw new Error('Unable to load 3D controls');
        return (await response.text()).replaceAll('../../../three.mjs', coreUrl);
      };
      const [THREE, orbitSource, roomSource] = await Promise.all([
        import(coreUrl), fetchModule('controls/OrbitControls'), fetchModule('environments/RoomEnvironment')
      ]);
      const urls = [orbitSource, roomSource].map(code => URL.createObjectURL(new Blob([code], { type: 'text/javascript' })));
      try {
        const modules = await Promise.allSettled(urls.map(url => import(url)));
        const failure = modules.find(result => result.status === 'rejected');
        if (failure) throw failure.reason;
        return [THREE, ...modules.map(result => result.value)];
      } finally {
        urls.forEach(url => URL.revokeObjectURL(url));
      }
    })().catch(error => { libraries = null; throw error; });
    return libraries;
  }

  
function buildEngine(THREE, palette = {}) {
  const group = new THREE.Group();
  group.name = '6.0 L Power Stroke — illustrative assembly';
  const parts = [];
  const C = (a, b, t) => new THREE.Color(a).lerp(new THREE.Color(b), t);
  const ironColor = palette.iron;
  const steelColor = palette.steel;
  const darkColor = palette.dark;
  const studColor = palette.stud;
  const M = {
    iron: new THREE.MeshStandardMaterial({ color: ironColor, metalness: .67, roughness: .54 }),
    cast: new THREE.MeshStandardMaterial({ color: C(ironColor, steelColor, .14), metalness: .72, roughness: .5 }),
    alloy: new THREE.MeshStandardMaterial({ color: C(steelColor, ironColor, .25), metalness: .86, roughness: .31 }),
    steel: new THREE.MeshStandardMaterial({ color: steelColor, metalness: .94, roughness: .27 }),
    dark: new THREE.MeshStandardMaterial({ color: darkColor, metalness: .30, roughness: .76 }),
    stud: new THREE.MeshStandardMaterial({ color: studColor, metalness: .9, roughness: .30 }),
    thread: new THREE.MeshStandardMaterial({ color: C(studColor, steelColor, .32), metalness: .96, roughness: .24 }),
    gasket: new THREE.MeshStandardMaterial({ color: C(darkColor, steelColor, .3), metalness: .82, roughness: .48 }),
    bore: new THREE.MeshStandardMaterial({ color: C(steelColor, darkColor, .7), metalness: .88, roughness: .29, side: THREE.DoubleSide }),
    brass: new THREE.MeshStandardMaterial({ color: C(steelColor, palette.accent, .12), metalness: .8, roughness: .37 }),
    rubber: new THREE.MeshStandardMaterial({ color: darkColor, metalness: .05, roughness: .9 }),
  };
  Object.entries(M).forEach(([name, material]) => { material.name = name; });
  const v = (x=0,y=0,z=0) => new THREE.Vector3(x,y,z);
  const mat4 = (p=[0,0,0], r=[0,0,0], s=[1,1,1]) => new THREE.Matrix4().compose(
    v(...p), new THREE.Quaternion().setFromEuler(new THREE.Euler(...r)), v(...s)
  );

  class Builder {
    constructor() { this.stack = [new THREE.Matrix4()]; this.items = new Map(); }
    at(p, r, fn) {
      this.stack.push(this.stack[this.stack.length - 1].clone().multiply(mat4(p,r)));
      fn(); this.stack.pop();
    }
    add(g, material, p=[0,0,0], r=[0,0,0], s=[1,1,1]) {
      const copy = g.index ? g.toNonIndexed() : g.clone();
      copy.applyMatrix4(this.stack[this.stack.length - 1].clone().multiply(mat4(p,r,s)));
      if (!copy.getAttribute('normal')) copy.computeVertexNormals();
      if (!this.items.has(material)) this.items.set(material, []);
      this.items.get(material).push(copy); g.dispose();
    }
    finish(target) {
      for (const [material, gs] of this.items) {
        const size = gs.reduce((n,g) => n + g.attributes.position.array.length, 0);
        const positions = new Float32Array(size), normals = new Float32Array(size);
        let cursor = 0;
        for (const g of gs) {
          positions.set(g.attributes.position.array,cursor);
          normals.set(g.attributes.normal.array,cursor);
          cursor += g.attributes.position.array.length;
          g.dispose();
        }
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.BufferAttribute(positions,3));
        geometry.setAttribute('normal', new THREE.BufferAttribute(normals,3));
        geometry.computeBoundingSphere();
        const mesh = new THREE.Mesh(geometry,material);
        mesh.castShadow = true; mesh.receiveShadow = true;
        target.add(mesh);
      }
    }
  }
  const box = (w,h,d) => new THREE.BoxGeometry(w,h,d);
  const cylinder = (rt,rb,h,n=24,open=false) => new THREE.CylinderGeometry(rt,rb,h,n,1,open);
  const torus = (r,t,radial=7,tubular=40,arc=Math.PI*2) => new THREE.TorusGeometry(r,t,radial,tubular,arc);
  function plate(w,l,h,r=.08,holes=[]) {
    const shape = new THREE.Shape();
    const x = -w/2, z = -l/2;
    shape.moveTo(x+r,z); shape.lineTo(x+w-r,z);
    shape.quadraticCurveTo(x+w,z,x+w,z+r); shape.lineTo(x+w,z+l-r);
    shape.quadraticCurveTo(x+w,z+l,x+w-r,z+l); shape.lineTo(x+r,z+l);
    shape.quadraticCurveTo(x,z+l,x,z+l-r); shape.lineTo(x,z+r);
    shape.quadraticCurveTo(x,z,x+r,z);
    for (const [hx,hz,hr] of holes) {
      const hole = new THREE.Path(); hole.absarc(hx,-hz,hr,0,Math.PI*2,true); shape.holes.push(hole);
    }
    const g = new THREE.ExtrudeGeometry(shape,{ depth:h, bevelEnabled:false, curveSegments:14, steps:1 });
    g.rotateX(-Math.PI/2); g.translate(0,-h/2,0); return g;
  }
  function profile(points, depth, bevel=.04) {
    const shape = new THREE.Shape(); shape.moveTo(...points[0]);
    points.slice(1).forEach(p => shape.lineTo(...p)); shape.closePath();
    const g = new THREE.ExtrudeGeometry(shape,{ depth, bevelEnabled:bevel>0, bevelSegments:2, steps:1, bevelSize:bevel, bevelThickness:bevel, curveSegments:8 });
    g.translate(0,0,-depth/2); return g;
  }
  function pipe(b, points, radius, material, segments=30) {
    b.add(new THREE.TubeGeometry(new THREE.CatmullRomCurve3(points.map(p=>v(...p))), segments, radius, 10, false),material);
  }
  function rod(b, a, c, radius, material, n=16) {
    const start=v(...a), end=v(...c), delta=end.clone().sub(start);
    const geo=cylinder(radius,radius,delta.length(),n);
    geo.applyQuaternion(new THREE.Quaternion().setFromUnitVectors(v(0,1,0),delta.normalize()));
    b.add(geo,material,start.add(end).multiplyScalar(.5).toArray());
  }
  function bolt(b,p,radius=.043,material=M.steel,rotation=[0,0,0]) {
    b.add(cylinder(radius,radius,.045,6),material,p,rotation);
  }
  function part(id,name,base,explode,description,build,rotation=[0,0,0]) {
    const pg=new THREE.Group(); pg.name=name; pg.position.copy(base); pg.rotation.set(...rotation);
    const builder=new Builder(); build(builder); builder.finish(pg);
    pg.userData.partId=id;
    pg.traverse(node => { if(node.isMesh) node.userData.partId=id; });
    group.add(pg); parts.push({ id, name, group:pg, base:base.clone(), explode:explode.clone(), description });
    return pg;
  }
  const boreZ=[-1.575,-.525,.525,1.575];
  const studZ=[-2.10,-1.05,0,1.05,2.10];
  const boreHoles=boreZ.map(z=>[0,z,.407]);
  const banks=[{sign:-1,id:'l',name:'Left bank'},{sign:1,id:'r',name:'Right bank'}];
  const bankOrigin=s=>v(s*.94,1.14,0);
  const bankAngle=s=>-s*Math.PI/4;
  const bankNormal=s=>v(s/Math.SQRT2,1/Math.SQRT2,0);
  function bankPoint(s,x,y,z) { return v(x,y,z).applyAxisAngle(v(0,0,1),bankAngle(s)).add(bankOrigin(s)); }

  part('block','Cylinder block',v(),v(),'The cast block supports both cylinder banks. Four visible bores on each bank show the V8 layout.',b=>{
    b.add(profile([[-1.10,-.74],[1.10,-.74],[1.20,.30],[.83,.62],[-.83,.62],[-1.20,.30]],4.62),M.iron,[0,-.05,0]);
    b.add(plate(2.43,4.83,.13,.14),M.cast,[0,-.85,0]);
    for(const {sign:s} of banks) {
      b.at(bankOrigin(s).toArray(),[0,0,bankAngle(s)],()=>{
        b.add(plate(1.43,4.65,.86,.09,boreHoles),M.iron,[0,-.47,0]);
        b.add(plate(1.45,4.67,.065,.075,boreHoles),M.steel,[0,-.005,0]);
        for(const z of boreZ) {
          b.add(cylinder(.405,.405,.77,36,true),M.bore,[0,-.417,z]);
          b.add(cylinder(.397,.397,.055,36),M.cast,[0,-.80,z]);
          b.add(torus(.402,.012,5,32),M.steel,[0,-.046,z],[Math.PI/2,0,0]);
          b.add(cylinder(.227,.227,.007,24),M.dark,[0,-.768,z]);
          b.add(torus(.227,.01,5,28),M.alloy,[0,-.761,z],[Math.PI/2,0,0]);
        }
        for(const x of [-.535,.535]) for(const z of studZ) {
          b.add(cylinder(.057,.057,.016,16),M.dark,[x,.033,z]);
          b.add(torus(.060,.008,5,16),M.alloy,[x,.041,z],[Math.PI/2,0,0]);
        }
        for(const z of [-1.97,-1.0,0,1.0,1.97]) {
          b.add(box(.085,.70,.13),M.cast,[s*.725,-.48,z]);
        }
      });
      for(const z of [-1.62,-.54,.54,1.62]) {
        b.add(cylinder(.14,.14,.045,20),M.brass,[s*1.15,-.07,z],[0,0,Math.PI/2]);
        b.add(torus(.15,.028,6,24),M.cast,[s*1.174,-.07,z],[0,Math.PI/2,0]);
      }
      for(const z of [-2.13,-1.1,0,1.1,2.13]) {
        bolt(b,[s*1.12,-.63,z],.047,M.steel,[0,0,Math.PI/2]);
      }
      b.add(box(.24,.38,.48),M.cast,[s*1.17,-.28,.65]);
      bolt(b,[s*1.31,-.22,.65],.09,M.steel,[0,0,Math.PI/2]);
    }
    b.add(plate(.77,1.71,.23,.10),M.cast,[0,1.12,.42]);
    for(let i=0;i<8;i++) b.add(box(.72,.023,.032),M.alloy,[0,1.249,-.17+i*.17]);
    b.add(plate(.73,.84,.3,.12),M.iron,[0,1.16,-1.41]);
    for(const x of [-.30,.30]) for(const z of [-1.73,-1.10]) bolt(b,[x,1.332,z]);
    b.add(cylinder(.58,.58,.28,32),M.cast,[0,-.15,-2.48],[Math.PI/2,0,0]);
    b.add(cylinder(.26,.26,.035,24),M.steel,[0,-.15,-2.64],[Math.PI/2,0,0]);
    b.add(cylinder(.11,.11,.047,16),M.dark,[0,-.15,-2.67],[Math.PI/2,0,0]);
  });

  for(const {sign:s,id,name} of banks) {
    const normal=bankNormal(s), rotation=[0,0,bankAngle(s)];
    part('head-'+id,name+' cylinder head',bankOrigin(s),normal.clone().multiplyScalar(2.05),
      'The cylinder head closes the combustion chambers and carries four valves per cylinder. Lifting it reveals the head studs and machined block deck.',b=>{
      b.add(plate(1.49,4.74,.54,.10),M.cast,[0,.33,0]);
      b.add(plate(1.48,4.73,.025,.065,boreHoles),M.gasket,[0,.046,0]);
      for(const z of boreZ) {
        b.add(cylinder(.406,.406,.012,32),M.bore,[0,.047,z]);
        b.add(torus(.40,.014,5,32),M.steel,[0,.032,z],[Math.PI/2,0,0]);
        for(const x of [-.16,.16]) for(const dz of [-.16,.16]) {
          b.add(cylinder(.118,.118,.011,20),M.steel,[x,.035,z+dz]);
        }
        b.add(cylinder(.044,.044,.022,14),M.dark,[0,.024,z]);
      }
      b.add(plate(1.20,4.42,.022,.09),M.dark,[0,.609,0]);
      for(const x of [-.686,.686]) b.add(box(.104,.14,4.49),M.alloy,[x,.648,0]);
      for(const z of [-2.27,2.27]) b.add(box(1.40,.14,.09),M.alloy,[0,.648,z]);
      for(const x of [-.43,.43]) {
        rod(b,[x,.737,-2.06],[x,.737,2.06],.043,M.steel,16);
      }
      for(const z of boreZ) {
        for(const x of [-.235,.235]) for(const dz of [-.18,.18]) {
          b.add(cylinder(.066,.066,.165,12),M.stud,[x,.707,z+dz]);
          for(let ring=0;ring<5;ring++) b.add(torus(.063,.012,5,12),M.thread,[x,.646+ring*.029,z+dz],[Math.PI/2,0,0]);
          b.add(cylinder(.081,.081,.024,16),M.steel,[x,.806,z+dz]);
        }
        for(const x of [-.235,.235]) {
          b.add(box(.081,.044,.44),M.alloy,[x,.84,z]);
          b.add(plate(.32,.095,.064,.025),M.alloy,[Math.sign(x)*.345,.856,z]);
          b.add(cylinder(.049,.049,.035,6),M.stud,[x,.884,z]);
        }
        b.add(cylinder(.093,.066,.27,16),M.steel,[0,.75,z]);
        b.add(cylinder(.071,.071,.089,6),M.brass,[0,.898,z]);
        b.add(box(.13,.095,.115),M.dark,[0,.99,z]);
        for(const side of [-1,1]) {
          b.add(plate(.38,.42,.052,.075),M.cast,[side*.757,.335,z],[0,0,Math.PI/2]);
          b.add(cylinder(.122,.122,.012,20),M.dark,[side*.79,.335,z],[0,0,Math.PI/2]);
          for(const dz of [-.255,.255]) bolt(b,[side*.79,.37,z+dz],.034,M.steel,[0,0,Math.PI/2]);
        }
      }
      for(const x of [-.535,.535]) for(const z of studZ) {
        b.add(cylinder(.092,.092,.023,20),M.stud,[x,.624,z]);
        b.add(cylinder(.075,.075,.092,6),M.stud,[x,.68,z]);
        b.add(torus(.044,.006,5,14),M.thread,[x,.73,z],[Math.PI/2,0,0]);
      }
    },rotation);

    part('studs-'+id,name+' head studs',bankOrigin(s),normal.clone().multiplyScalar(.90),
      'Ten illustrative main head studs per bank are threaded into the block. The head fits over the studs; washers and nuts provide the clamp load.',b=>{
      for(const x of [-.535,.535]) for(const z of studZ) {
        b.add(cylinder(.041,.041,1.24,14),M.stud,[x,.23,z]);
        b.add(cylinder(.043,.043,.28,14),M.thread,[x,-.27,z]);
        for(let ring=0;ring<9;ring++) b.add(torus(.044,.007,5,14),M.thread,[x,.528+ring*.037,z],[Math.PI/2,0,0]);
        for(let ring=0;ring<6;ring++) b.add(torus(.044,.007,5,14),M.thread,[x,-.365+ring*.039,z],[Math.PI/2,0,0]);
        b.add(cylinder(.031,.041,.023,12),M.thread,[x,.86,z]);
        b.add(cylinder(.018,.018,.004,6),M.dark,[x,.873,z]);
      }
    },rotation);

    part('cover-'+id,name+' valve cover',bankOrigin(s),normal.clone().multiplyScalar(3.55),
      'The valve cover protects the rocker arms, valve springs and injector connections above the cylinder head.',b=>{
      b.add(plate(1.39,4.68,.058,.17),M.dark,[0,.958,0]);
      b.add(profile([[-.63,0],[-.63,.18],[-.53,.30],[-.30,.38],[.30,.38],[.53,.30],[.63,.18],[.63,0]],4.41,.055),M.iron,[0,.981,0]);
      for(const x of [-.36,-.18,0,.18,.36]) b.add(plate(.032,3.56,.037,.016),M.cast,[x,1.405,0]);
      for(const x of [-.644,.644]) for(const z of [-1.98,-.67,.67,1.98]) {
        b.add(cylinder(.073,.073,.042,18),M.cast,[x,1.00,z]); bolt(b,[x,1.035,z],.045,M.steel);
      }
      b.add(plate(.33,.84,.065,.07),M.dark,[0,1.427,.3]);
      b.add(plate(.235,.61,.016,.03),M.alloy,[0,1.468,.3]);
      if(s===1) {
        b.add(cylinder(.19,.15,.20,24),M.dark,[.02,1.48,1.36]);
        b.add(cylinder(.205,.205,.07,12),M.dark,[.02,1.61,1.36]);
        for(let i=0;i<8;i++) {
          const a=i*Math.PI/4;
          b.add(box(.044,.052,.053),M.cast,[.02+Math.cos(a)*.19,1.61,1.36+Math.sin(a)*.19],[0,-a,0]);
        }
      }
    },rotation);
  }

  part('pan','Oil pan',v(),v(0,-1.70,0),
    'The oil pan is the reservoir beneath the crankcase. Its sump collects oil returning from the engine.',b=>{
    b.add(plate(2.38,4.78,.088,.16),M.alloy,[0,-.939,0]);
    b.add(plate(2.30,4.70,.024,.13),M.gasket,[0,-.88,0]);
    b.add(profile([[-1.10,0],[1.10,0],[1.00,-.42],[.79,-.57],[-.79,-.57],[-1.00,-.42]],4.47,.065),M.iron,[0,-1.00,0]);
    b.add(plate(1.88,2.06,.32,.18),M.iron,[0,-1.67,-.93]);
    for(const z of [-1.92,-1.44,-.96,-.48,0,.48,.96,1.44,1.92]) {
      b.add(box(2.05,.067,.071),M.cast,[0,-1.50,z]);
    }
    for(const x of [-1.02,1.02]) for(const z of [-2.14,-1.52,-.9,-.3,.3,.9,1.52,2.14]) bolt(b,[x,-.884,z],.043,M.steel);
    b.add(cylinder(.12,.12,.08,6),M.steel,[0,-1.69,1.10]);
  });

  part('intake','Intake and valley hardware',v(),v(0,3.20,.25),
    'The intake routes compressed air toward the two cylinder banks. The nearby vertical housings represent the oil and fuel filter hardware.',b=>{
    b.add(plate(.83,2.82,.32,.20),M.alloy,[0,1.73,.25]);
    for(const s of [-1,1]) for(const z of [-.90,-.12,.66,1.44]) {
      const end=bankPoint(s,-s*.49,.30,z);
      pipe(b,[[s*.32,1.69,z],[s*.58,1.72,z],[end.x,end.y+.11,z]],.145,M.alloy,12);
      b.add(cylinder(.18,.18,.042,18),M.cast,[end.x,end.y+.07,z],[0,0,bankAngle(s)]);
    }
    pipe(b,[[0,1.78,1.33],[0,2.05,1.66],[0,2.40,1.62],[0,2.56,1.35]],.255,M.alloy,22);
    b.add(cylinder(.275,.275,.105,24),M.rubber,[0,2.56,1.35],[Math.PI/2,0,0]);
    for(const z of [1.29,1.40]) b.add(torus(.282,.015,5,28),M.steel,[0,2.56,z]);
    b.add(cylinder(.252,.252,.009,28),M.dark,[0,2.56,1.416],[Math.PI/2,0,0]);
    b.add(plate(.46,.35,.06,.04),M.cast,[0,1.922,.25]);
    for(const x of [-.17,.17]) for(const z of [.14,.37]) bolt(b,[x,1.972,z],.031,M.steel);
    for(const [x,z,rad,h] of [[-.53,1.06,.23,.60],[.46,.88,.205,.48]]) {
      b.add(cylinder(rad,rad*.92,h,24),M.cast,[x,1.93,z]);
      b.add(cylinder(rad*1.08,rad*1.08,.13,12),M.dark,[x,1.93+h/2+.047,z]);
      b.add(cylinder(rad*.35,rad*.35,.055,6),M.dark,[x,1.93+h/2+.132,z]);
    }
    pipe(b,[[.48,1.81,.68],[.61,1.91,.16],[.63,1.89,-.69]],.037,M.steel,18);
  });

  part('turbo','Turbocharger',v(),v(0,3.15,-2.2),
    'The rear-mounted turbocharger uses exhaust energy to compress incoming air. The visible inlet and compressor wheel illustrate the air side.',b=>{
    const tc=[0,2.47,-1.66];
    b.at(tc,[0,0,0],()=>{
      b.add(cylinder(.31,.31,.71,24),M.cast,[0,0,-.35],[Math.PI/2,0,0]);
      b.add(torus(.42,.18,10,42),M.iron,[0,0,-.71]);
      b.add(cylinder(.28,.28,.27,24),M.iron,[0,0,-.89],[Math.PI/2,0,0]);
      b.add(torus(.285,.029,6,30),M.steel,[0,0,-1.031]);
      b.add(cylinder(.25,.25,.01,24),M.dark,[0,0,-1.04],[Math.PI/2,0,0]);
      const spiral=[];
      for(let i=0;i<=54;i++) {
        const a=(i/54)*Math.PI*2+.30, r=.40+.14*i/54;
        spiral.push([Math.cos(a)*r,Math.sin(a)*r,0]);
      }
      pipe(b,spiral,.177,M.alloy,60);
      pipe(b,[[.50,.14,0],[.47,.49,0],[.18,.69,0],[-.13,.71,0]],.18,M.alloy,20);
      b.add(cylinder(.197,.197,.11,24),M.dark,[-.145,.71,0],[0,0,Math.PI/2]);
      b.add(torus(.20,.018,6,26),M.steel,[-.201,.71,0],[0,Math.PI/2,0]);
      const inletProfile=[v(.29,0),v(.36,.04),v(.41,.12),v(.35,.25),v(.286,.31),v(.272,.33)];
      b.add(new THREE.LatheGeometry(inletProfile,40),M.alloy,[0,0,.065],[Math.PI/2,0,0]);
      b.add(torus(.279,.027,7,36),M.steel,[0,0,.398]);
      b.add(cylinder(.269,.269,.015,32),M.dark,[0,0,.34],[Math.PI/2,0,0]);
      for(let i=0;i<11;i++) {
        const shape=new THREE.Shape();
        shape.moveTo(.062,-.012); shape.quadraticCurveTo(.17,-.076,.258,-.021);
        shape.lineTo(.25,.018); shape.quadraticCurveTo(.16,-.008,.082,.040); shape.closePath();
        const blade=new THREE.ExtrudeGeometry(shape,{depth:.022,bevelEnabled:false,curveSegments:4});
        b.add(blade,M.steel,[0,0,.354],[0,0,i*Math.PI*2/11]);
      }
      b.add(cylinder(.079,.033,.14,22),M.alloy,[0,0,.419],[Math.PI/2,0,0]);
      b.add(cylinder(.038,.038,.027,6),M.steel,[0,0,.50],[Math.PI/2,0,0]);
      for(let i=0;i<6;i++) {
        const a=i*Math.PI/3;
        bolt(b,[Math.cos(a)*.343,Math.sin(a)*.343,.20],.034,M.steel,[Math.PI/2,0,0]);
      }
      b.add(plate(.72,.83,.15,.1),M.cast,[0,-.68,-.42]);
      b.add(box(.40,.23,.48),M.cast,[0,-.48,-.43]);
    });
    for(const s of [-1,1]) {
      pipe(b,[[s*1.39,1.28,-1.65],[s*1.17,1.30,-2.39],[s*.52,1.72,-2.50],[s*.25,2.28,-2.38]],.112,M.iron,27);
      b.add(torus(.128,.021,6,22),M.steel,[s*1.39,1.28,-1.65]);
    }
    pipe(b,[[-.15,3.18,-1.66],[-.56,3.14,-1.46],[-.57,2.79,-.77],[-.38,2.59,-.47]],.178,M.alloy,30);
    b.add(cylinder(.184,.184,.16,22),M.rubber,[-.38,2.59,-.47],[Math.PI/2,0,0]);
    for(const z of [-.55,-.39]) b.add(torus(.192,.017,5,26),M.steel,[-.38,2.59,z]);
    pipe(b,[[.06,2.06,-1.88],[.21,1.88,-1.38],[.16,1.42,-1.29]],.032,M.steel,16);
  });

  part('front','Front drive and accessories',v(),v(0,0,2.2),
    'The front drive turns the accessory pulleys. The large lower pulley represents the crankshaft damper; the upper vented housing is the alternator.',b=>{
    b.add(profile([[-1.15,-.68],[1.15,-.68],[1.23,.04],[.89,.65],[.53,.83],[-.53,.83],[-.89,.65],[-1.23,.04]],.15,.04),M.cast,[0,-.08,2.39]);
    for(const x of [-1.03,1.03]) for(const y of [-.57,-.05,.38]) bolt(b,[x,y,2.51],.047,M.steel,[Math.PI/2,0,0]);
    function pulley(x,y,z,r,w=.16,mat=M.dark) {
      b.add(cylinder(r,r,w,36),mat,[x,y,z],[Math.PI/2,0,0]);
      b.add(cylinder(r*.69,r*.69,.035,30),M.cast,[x,y,z+w/2+.012],[Math.PI/2,0,0]);
      b.add(torus(r*.98,.023,6,36),M.steel,[x,y,z+w/2]);
      b.add(cylinder(r*.16,r*.16,.07,6),M.steel,[x,y,z+w/2+.056],[Math.PI/2,0,0]);
      for(let i=0;i<5;i++) {
        const a=i*Math.PI*2/5;
        b.add(cylinder(r*.075,r*.075,.007,12),M.dark,[x+Math.cos(a)*r*.45,y+Math.sin(a)*r*.45,z+w/2+.033],[Math.PI/2,0,0]);
      }
    }
    pulley(0,-.34,2.65,.58,.26);
    pulley(-.92,.57,2.72,.36,.17);
    pulley(.97,.49,2.72,.33,.17);
    pulley(.33,1.01,2.72,.205,.16);
    pulley(-.09,.56,2.72,.235,.15);
    const beltPoints=[[-.34,-.80,2.76],[-.63,-.61,2.76],[-1.22,.35,2.76],[-1.28,.63,2.76],[-1.10,.88,2.76],[-.87,.94,2.76],[.16,1.16,2.76],[.36,1.22,2.76],[.57,1.08,2.76],[1.16,.77,2.76],[1.31,.50,2.76],[1.22,.24,2.76],[.50,-.64,2.76],[.24,-.89,2.76],[-.12,-.92,2.76],[-.34,-.80,2.76]];
    pipe(b,beltPoints,.042,M.rubber,72);
    pipe(b,beltPoints.map(p=>[p[0],p[1],p[2]-.095]),.042,M.rubber,72);
    b.add(cylinder(.405,.405,.59,30),M.alloy,[-.92,.57,2.27],[Math.PI/2,0,0]);
    b.add(cylinder(.365,.365,.41,26),M.dark,[-.92,.57,2.23],[Math.PI/2,0,0]);
    for(let i=0;i<16;i++) {
      const a=i*Math.PI/8;
      b.add(box(.066,.092,.43),M.alloy,[-.92+Math.cos(a)*.365,.57+Math.sin(a)*.365,2.22],[0,0,a]);
    }
    b.add(cylinder(.392,.392,.08,28),M.alloy,[-.92,.57,2.47],[Math.PI/2,0,0]);
    for(const x of [-1.35,-.53]) b.add(box(.17,.20,.36),M.cast,[x,.52,2.14]);
    b.add(cylinder(.36,.36,.46,24),M.cast,[.97,.49,2.30],[Math.PI/2,0,0]);
    b.add(cylinder(.33,.33,.04,24),M.dark,[.97,.49,2.03],[Math.PI/2,0,0]);
    b.add(cylinder(.27,.32,.24,24),M.alloy,[0,.17,2.47],[Math.PI/2,0,0]);
    pipe(b,[[.42,.53,2.38],[.63,.77,2.32],[.65,1.03,2.21]],.115,M.alloy,16);
    b.add(torus(.127,.019,6,22),M.steel,[.65,1.04,2.21],[Math.PI/2,0,0]);
  });

  return { group, parts };
}


  function createViewer(root, [THREE, { OrbitControls }, { RoomEnvironment }], fail) {
    const strings = root.strings;
    const oldCanvas = root.querySelector('canvas');
    const canvas = oldCanvas.cloneNode(false);
    oldCanvas.replaceWith(canvas);
    canvas.hidden = false;
    const stage = root.querySelector('[data-stage]');
    const picker = root.querySelector('[data-part]');
    const slider = root.querySelector('[data-separation]');
    const percent = root.querySelector('[data-percent]');
    const separationLabel = root.querySelector('[data-separation-label]');
    const view = root.querySelector('[data-view]');
    const detail = root.querySelector('[data-detail]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const on = (target, type, handler) => target.addEventListener(type, handler, { signal: events.signal });
    let renderer, environment, controls, engine, resizeObserver, visibilityObserver;
    let disposed = false, active = true, frame = 0, lastTime = 0;
    function dispose() {
      if (disposed) return;
      disposed = true;
      cancelAnimationFrame(frame);
      events.abort();
      resizeObserver?.disconnect();
      visibilityObserver?.disconnect();
      controls?.dispose();
      if (engine) {
        const geometries = new Set(), materials = new Set();
        engine.group.traverse(mesh => {
          if (mesh.geometry) geometries.add(mesh.geometry);
          if (mesh.material) materials.add(mesh.material);
          if (mesh.userData.baseMaterial) materials.add(mesh.userData.baseMaterial);
        });
        geometries.forEach(geometry => geometry.dispose());
        materials.forEach(material => material.dispose());
      }
      environment?.dispose();
      renderer?.dispose();
      renderer?.forceContextLoss();
    }
    try {
      const appearance = getComputedStyle(root);
      const background = new THREE.Color(appearance.getPropertyValue('--xee-background').trim());
      const foreground = new THREE.Color(appearance.getPropertyValue('--xee-foreground').trim());
      const accent = new THREE.Color(appearance.getPropertyValue('--xee-accent').trim());
      const light = background.getHSL({}).l > .5;
      const mix = amount => '#' + background.clone().lerp(foreground, amount).getHexString();
      const palette = {
        iron: mix(light ? .84 : .19), steel: mix(light ? .42 : .65),
        dark: mix(light ? .96 : .06), stud: mix(light ? .9 : .12), accent: '#' + accent.getHexString()
      };
      const scene = new THREE.Scene();
      try {
        renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
      } catch (error) {
        error.viewerMessage = strings.webgl_error;
        throw error;
      }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.setClearColor(0, 0);
      renderer.outputColorSpace = THREE.SRGBColorSpace;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = .86;
      const pmrem = new THREE.PMREMGenerator(renderer);
      const room = new RoomEnvironment();
      try { environment = pmrem.fromScene(room, .04); }
      finally { room.dispose(); pmrem.dispose(); }
      scene.environment = environment.texture;
      scene.environmentIntensity = .65;
      const bright = light ? background : foreground;
      const dim = (light ? foreground : background).clone().lerp(bright, .35);
      scene.add(new THREE.HemisphereLight(bright, dim, 1.15));
      const key = new THREE.DirectionalLight(bright, 2.8);
      key.position.set(4, 8, 7);
      scene.add(key);
      const fill = new THREE.DirectionalLight(bright, 1.3);
      fill.position.set(-5, 4, -4);
      scene.add(fill);
      const camera = new THREE.PerspectiveCamera(36, 1, .05, 200);
      camera.position.set(9, 7, 11);
      controls = new OrbitControls(camera, canvas);
      controls.enableDamping = !reducedMotion.matches;
      controls.dampingFactor = .12;
      controls.enablePan = true;
      controls.enableZoom = false;
      const touchQuery = matchMedia('(pointer: coarse)');
      const touchButton = root.querySelector('[data-touch-rotate]');
      let touchMode = false;
      function setTouchMode(enabled) {
        touchMode = Boolean(enabled);
        controls.enabled = !touchQuery.matches || touchMode;
        canvas.style.touchAction = touchMode ? 'none' : 'pan-y pinch-zoom';
        touchButton.setAttribute('aria-pressed', String(touchMode));
        touchButton.textContent = touchMode ? strings.done_rotating : strings.rotate_model;
      }
      setTouchMode(false);
      on(touchButton, 'click', () => setTouchMode(!touchMode));
      on(touchQuery, 'change', () => { setTouchMode(false); touchButton.hidden = !touchQuery.matches; });
      on(root, 'keydown', event => { if (event.key === 'Escape' && touchMode) { event.preventDefault(); setTouchMode(false); } });
      canvas.addEventListener('pointerdown', event => { controls.enabled = event.pointerType !== 'touch' || touchMode; }, { capture: true, signal: events.signal });
      controls.minDistance = 3;
      controls.maxDistance = 45;
      controls.target.set(0, .8, 0);
      controls.update();
      engine = buildEngine(THREE, palette);
      scene.add(engine.group);
      let selected = 'all';
      let assemblyValue = 0;
      let customAssembly = false;
      const amounts = new Map();
      function requestRender() {
        if (frame || disposed || !active || document.hidden) return;
        frame = requestAnimationFrame(render);
      }
      function render(time) {
        frame = 0;
        if (disposed || !active || document.hidden) return;
        const step = reducedMotion.matches ? 1 : Math.min(1, 1 - Math.exp(-Math.min(time - lastTime, 60) / 65));
        lastTime = time;
        let moving = false;
        for (const part of engine.parts) {
          const target = part.base.clone().addScaledVector(part.explode, amounts.get(part.id) || 0);
          if (part.group.position.distanceToSquared(target) > 1e-7) {
            part.group.position.lerp(target, step);
            moving = true;
          } else part.group.position.copy(target);
        }
        controls.update();
        renderer.render(scene, camera);
        if (moving) requestRender();
      }
      controls.addEventListener('change', requestRender);
      for (const part of engine.parts) {
        part.name = strings.parts[part.id.replace('-', '_')];
        part.group.traverse(mesh => {
          if (!mesh.isMesh) return;
          mesh.userData.partId = part.id;
          mesh.userData.baseMaterial = mesh.material;
          const positions = mesh.geometry.getAttribute('position');
          mesh.userData.fitPoints = [];
          for (let index = 0; index < positions.count; index += 24) {
            mesh.userData.fitPoints.push(new THREE.Vector3().fromBufferAttribute(positions, index));
          }
        });
      }
      function highlight() {
        for (const part of engine.parts) part.group.traverse(mesh => {
          if (!mesh.isMesh) return;
          if (mesh.material !== mesh.userData.baseMaterial) mesh.material.dispose();
          mesh.material = mesh.userData.baseMaterial;
          if (part.id === selected) {
            mesh.material = mesh.material.clone();
            mesh.material.color.lerp(accent, .48);
            if (mesh.material.emissive) {
              mesh.material.emissive.copy(accent);
              mesh.material.emissiveIntensity = .13;
            }
          }
        });
        requestRender();
      }
      function fit(direction) {
        const saved = engine.parts.map(part => part.group.position.clone());
        engine.parts.forEach(part => part.group.position.copy(part.base).addScaledVector(part.explode, amounts.get(part.id) || 0));
        engine.group.updateMatrixWorld(true);
        const box = new THREE.Box3().setFromObject(engine.group);
        const center = box.getCenter(new THREE.Vector3());
        const vertical = THREE.MathUtils.degToRad(camera.fov);
        const horizontal = 2 * Math.atan(Math.tan(vertical / 2) * camera.aspect);
        const heading = (direction || camera.position.clone().sub(controls.target)).normalize();
        const right = new THREE.Vector3().crossVectors(camera.up, heading).normalize();
        const up = new THREE.Vector3().crossVectors(heading, right).normalize();
        let distance = 0;
        const corner = new THREE.Vector3();
        engine.group.traverse(mesh => {
          if (!mesh.isMesh) return;
          for (const point of mesh.userData.fitPoints) {
            corner.copy(point).applyMatrix4(mesh.matrixWorld).sub(center);
            distance = Math.max(distance,
              corner.dot(heading) + Math.abs(corner.dot(right)) / Math.tan(horizontal / 2),
              corner.dot(heading) + Math.abs(corner.dot(up)) / Math.tan(vertical / 2));
          }
        });
        engine.parts.forEach((part, index) => part.group.position.copy(saved[index]));
        engine.group.updateMatrixWorld(true);
        controls.target.copy(center);
        camera.position.copy(center).addScaledVector(heading, Math.min(44, distance * 1.06));
        controls.update();
        requestRender();
      }
      function syncSelection() {
        picker.value = selected;
        const part = engine.parts.find(part => part.id === selected);
        const amount = selected === 'all' ? assemblyValue : amounts.get(selected) || 0;
        slider.value = String(Math.round(amount * 100));
        percent.textContent = selected === 'all' && customAssembly ? strings.custom : Math.round(amount * 100) + '%';
        const label = selected === 'all' ? strings.assembly_separation : strings.part_separation;
        separationLabel.textContent = label;
        slider.setAttribute('aria-label', label);
        slider.setAttribute('aria-valuetext', percent.textContent);
        detail.textContent = part ? part.name + ' · ' + strings.descriptions[part.id.replace('-', '_')] : strings.assembly_detail;
        slider.disabled = selected === 'block';
        highlight();
      }
      function applyAssembly(value, snap = false) {
        assemblyValue = value;
        customAssembly = false;
        for (const part of engine.parts) {
          const amount = part.id.startsWith('studs-') ? Math.max(0, (value - .65) / .35) : value;
          amounts.set(part.id, part.id === 'block' ? 0 : amount);
          if (snap) part.group.position.copy(part.base).addScaledVector(part.explode, amounts.get(part.id));
        }
        syncSelection();
        fit();
      }
      picker.replaceChildren(new Option(strings.whole_assembly, 'all'));
      for (const part of engine.parts) picker.add(new Option(part.name, part.id));
      on(picker, 'change', () => { selected = picker.value; syncSelection(); });
      on(slider, 'input', () => {
        const value = Number(slider.value) / 100;
        if (selected === 'all') applyAssembly(value);
        else {
          amounts.set(selected, value);
          customAssembly = true;
          syncSelection();
          fit();
        }
      });
      const directions = {
        angle: new THREE.Vector3(9, 7, 11), front: new THREE.Vector3(0, 2, 12),
        rear: new THREE.Vector3(0, 3, -12), left: new THREE.Vector3(-12, 4, 1),
        right: new THREE.Vector3(12, 4, 1), top: new THREE.Vector3(0, 12, .001)
      };
      on(view, 'change', () => fit(directions[view.value].clone()));
      function zoom(factor) {
        const offset = camera.position.clone().sub(controls.target);
        const distance = THREE.MathUtils.clamp(offset.length() * factor, controls.minDistance, controls.maxDistance);
        camera.position.copy(controls.target).addScaledVector(offset.normalize(), distance);
        controls.update();
        requestRender();
      }
      root.querySelectorAll('[data-zoom]').forEach(button => on(button, 'click', () => zoom(button.dataset.zoom === 'in' ? .8 : 1.25)));
      function inspectStuds(snap = false) {
        for (const part of engine.parts) amounts.set(part.id, 0);
        amounts.set('head-r', .8);
        amounts.set('cover-r', 1);
        amounts.set('intake', .38);
        amounts.set('turbo', .12);
        selected = 'studs-r';
        customAssembly = true;
        view.value = 'angle';
        syncSelection();
        if (snap) engine.parts.forEach(part => part.group.position.copy(part.base).addScaledVector(part.explode, amounts.get(part.id) || 0));
        fit(new THREE.Vector3(12, 4, 11));
      }
      on(root.querySelector('[data-stud-view]'), 'click', () => inspectStuds());
      on(root.querySelector('[data-reset]'), 'click', () => {
        selected = 'all';
        view.value = 'angle';
        applyAssembly(0);
        fit(directions.angle.clone());
      });
      on(canvas, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === '+' || event.key === '=') { event.preventDefault(); zoom(.8); return; }
        if (event.key === '-') { event.preventDefault(); zoom(1.25); return; }
        if (event.key === 'Home') { event.preventDefault(); fit(directions.angle.clone()); return; }
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const offset = camera.position.clone().sub(controls.target);
        const spherical = new THREE.Spherical().setFromVector3(offset);
        if (event.key === 'ArrowLeft') spherical.theta -= .12;
        if (event.key === 'ArrowRight') spherical.theta += .12;
        if (event.key === 'ArrowUp') spherical.phi -= .12;
        if (event.key === 'ArrowDown') spherical.phi += .12;
        spherical.makeSafe();
        camera.position.copy(controls.target).add(new THREE.Vector3().setFromSpherical(spherical));
        controls.update();
        requestRender();
      });
      const raycaster = new THREE.Raycaster();
      const pointer = new THREE.Vector2();
      let down = null, gesture = false;
      const touches = new Set();
      on(canvas, 'pointerdown', event => {
        if (event.pointerType === 'touch' && !touchMode) return;
        touches.add(event.pointerId);
        if (touches.size === 1) { down = { x: event.clientX, y: event.clientY, id: event.pointerId }; gesture = false; }
        else gesture = true;
      });
      on(canvas, 'pointermove', event => {
        if (down && Math.hypot(event.clientX - down.x, event.clientY - down.y) > 5) gesture = true;
      });
      on(canvas, 'pointerup', event => {
        touches.delete(event.pointerId);
        if (!down || down.id !== event.pointerId || gesture) { if (!touches.size) down = null; return; }
        down = null;
        const rect = canvas.getBoundingClientRect();
        pointer.set((event.clientX - rect.left) / rect.width * 2 - 1, -(event.clientY - rect.top) / rect.height * 2 + 1);
        raycaster.setFromCamera(pointer, camera);
        const hit = raycaster.intersectObject(engine.group, true).find(item => item.object.userData.partId);
        selected = hit ? hit.object.userData.partId : 'all';
        syncSelection();
      });
      on(canvas, 'pointercancel', event => { touches.delete(event.pointerId); down = null; });
      resizeObserver = new ResizeObserver(() => {
        const width = stage.clientWidth, height = stage.clientHeight;
        if (!width || !height) return;
        renderer.setSize(width, height, false);
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        fit();
      });
      resizeObserver.observe(stage);
      visibilityObserver = new IntersectionObserver(entries => {
        active = entries[0].isIntersecting;
        if (active) requestRender();
      });
      visibilityObserver.observe(root);
      on(document, 'visibilitychange', requestRender);
      on(reducedMotion, 'change', () => { controls.enableDamping = !reducedMotion.matches; requestRender(); });
      on(canvas, 'webglcontextlost', event => { event.preventDefault(); fail(strings.context_lost); });
      view.value = 'angle';
      renderer.setSize(stage.clientWidth, stage.clientHeight, false);
      camera.aspect = stage.clientWidth / stage.clientHeight;
      camera.updateProjectionMatrix();
      inspectStuds(true);
      renderer.render(scene, camera);
      requestRender();
      touchButton.hidden = !touchQuery.matches;
      return dispose;
    } catch (error) {
      dispose();
      throw error;
    }
  }

  class XoticEngineExplorer extends HTMLElement {
    connectedCallback() {
      const generation = (this.generation || 0) + 1;
      this.generation = generation;
      queueMicrotask(() => {
        if (!this.isConnected || this.generation !== generation || this.connection) return;
        this.connection = new AbortController();
        this.strings = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.launch = this.querySelector('[data-retry]');
        this.poster = this.querySelector('[data-poster]');
        this.status = this.querySelector('[data-status]');
        this.stage = this.querySelector('[data-stage]');
        this.overlay = this.querySelector('[data-overlay]');
        this.controlsPanel = this.querySelector('[data-controls]');
        this.reset();
        this.launch.addEventListener('click', () => this.load(), { signal: this.connection.signal });
        this.autoObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.autoObserver.disconnect();
            this.load();
          }
        }, { rootMargin: '400px 0px' });
        this.autoObserver.observe(this);
      });
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.autoObserver?.disconnect();
      this.connection?.abort();
      this.connection = null;
      this.disposeViewer?.();
      this.disposeViewer = null;
    }
    reset(message) {
      this.disposeViewer?.();
      this.disposeViewer = null;
      this.loading = false;
      this.querySelector('canvas').hidden = true;
      this.controlsPanel.inert = true;
      this.controlsPanel.setAttribute('aria-hidden', 'true');
      this.poster.hidden = false;
      this.querySelector('[data-touch-rotate]').hidden = true;
      this.overlay.hidden = false;
      this.launch.disabled = false;
      this.launch.hidden = !message;
      this.launch.textContent = this.strings.retry;
      this.status.textContent = message || this.strings.loading_detail;
      this.status.setAttribute('role', message ? 'alert' : 'status');
      this.stage.setAttribute('aria-busy', 'false');
      this.dataset.state = message ? 'error' : 'idle';
    }
    async load() {
      if (this.loading || this.disposeViewer) return;
      this.loading = true;
      this.autoObserver?.disconnect();
      this.launch.hidden = true;
      const generation = this.generation;
      this.launch.disabled = true;
      this.launch.textContent = this.strings.loading;
      this.status.textContent = this.strings.loading_detail;
      this.status.setAttribute('role', 'status');
      this.stage.setAttribute('aria-busy', 'true');
      this.dataset.state = 'loading';
      try {
        const loaded = await getLibraries();
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (!this.isConnected || this.generation !== generation) return;
        this.disposeViewer = createViewer(this, loaded, message => this.reset(message));
        this.loading = false;
        this.overlay.hidden = true;
        this.poster.hidden = true;
        this.controlsPanel.inert = false;
        this.controlsPanel.removeAttribute('aria-hidden');
        this.stage.setAttribute('aria-busy', 'false');
        this.dataset.state = 'ready';
      } catch (error) {
        if (!this.isConnected || this.generation !== generation) return;
        this.reset(error.viewerMessage || this.strings.load_error);
      }
    }
  }
  customElements.define('xotic-engine-explorer', XoticEngineExplorer);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xotic-wholesale-prototype"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.xoticWholesaleResizeAttached) return;
  window.xoticWholesaleResizeAttached = true;
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://formbuilder.hulkapps.com') return;
    const data = event.data;
    if (!data || typeof data !== 'object' || typeof data.formid !== 'string') return;
    document.querySelectorAll('.xotic-wholesale .xw-iframe-wrap').forEach((wrapper) => {
      const frame = wrapper.querySelector('iframe');
      if (!frame || frame.contentWindow !== event.source || wrapper.dataset.xwForm !== data.formid) return;
      const height = Number(data.height);
      if (Number.isFinite(height) && height > 0) frame.style.height = `${Math.min(20000, Math.max(160, Math.ceil(height)))}px`;
      if (data.scroll_to) frame.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
